import React, { useEffect, useMemo, useState, useCallback } from 'react';
import AppointmentTable from '@/ctComponents/AppointmentTable';
import { availableApointments, NewAppointmentsFilter } from '@/actions';
import CustomSelectEx from '@/ctComponents/CustomSelectEx';
import { CustomGrid, CustomGridItem } from '@/ctComponents/Grid';
import { debounce } from 'lodash';
import { usePusher } from '../../App';
import LoadingV2 from '@/components/Loading';
import PageContainerAB from '@/components/PageContainerAB/pageContainer';

export default () => {
  const { channels } = usePusher();
  const [appointmentSet, setAppointmentSet] = useState(null);
  const [appointmentData, setAppointmentData] = useState([]);
  const [shift, setShift] = useState(true);
  const [sizeOptions, setSizeOptions] = useState([]);
  const [SSLOptions, setSSLOptions] = useState([]);
  const [ContainerOptions, setContainerOptions] = useState([]);
  const [selected, setSelected] = useState({});
  const [selectedFromApi, setSelectedFromApi] = useState({
    SSL: {
      label: null,
      value: null,
    },
    Size: {
      label: null,
      value: null,
    },
  });
  const [cabinId, setCabinId] = useState();
  const [cabins, setCabins] = useState([]);
  const [changeConatiner, setChangeConatiner] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (channels?.publicChannel) {
      const handleUpdateData = (data) => {
        const pusherUpdateMessage = data.message;
        if (
          pusherUpdateMessage.specificationId === selected?.Size?.value &&
          pusherUpdateMessage.sslId === selected?.SSL?.value
        ) {
          getApointment();
          console.log('handleUpdateData');
        }
      };

      channels.publicChannel.bind(
        'AppointmentAvailabilityUpdated',
        handleUpdateData
      );

      return () => {
        channels.publicChannel.unbind(
          'AppointmentAvailabilityUpdated',
          handleUpdateData
        );
      };
    }
  }, [channels, selected?.SSL?.value, selected?.Size?.value]);

  useEffect(() => {
    NewAppointmentsFilter({
      company: null,
      specifiation: null,
    }).then((res) => {
      setCabins(res.data?.cabins);
      setSizeOptions(
        res.data.specifications.map(({ id, size, name, model }) => ({
          value: id,
          label: `${size}${name ? '-' + name : ''}-${model}`,
        }))
      );
      setSSLOptions(
        res.data.companies.map(({ id, name }) => ({
          value: id,
          label: name,
        }))
      );
      setSelected({
        Size: {
          value: 4,
          label: '40-HC-Dry',
        },
        SSL: { value: 3, label: 'CMA-CGM' },
        Container: {},
      });
    });
  }, []);

  const getApointment = useCallback(() => {
    console.log('getApointment');
    setLoading(true); // loading را در ابتدا true می‌کنیم

    if (
      selected?.SSL?.value &&
      selected?.Size?.value
      // selected?.Container?.value
    ) {
      availableApointments({
        ssl: selected?.SSL?.value,
        size: selected?.Size?.value,
        containerId: selected?.Container?.value,
        newAppointment: true,
      })
        .then((res) => {
          setSelectedFromApi({
            SSL: {
              label:
                SSLOptions.find(
                  (item) =>
                    item.value === res?.container_data?.cabin?.company?.id
                )?.label || null,
              value: res?.container_data?.cabin?.company?.id || null,
            },
            Size: {
              label:
                sizeOptions.find(
                  (item) =>
                    item.value ===
                    res?.container_data?.cabin?.specifications?.id
                )?.label || null,
              value: res?.container_data?.cabin?.specifications?.id || null,
            },
          });
          const { availability, terminals } = res;
          setShift(res.active_shift === 'shift1' ? true : false);
          const terminalSlugs = Object.fromEntries(
            Object.entries(terminals).map(([id, terminal]) => [
              id,
              terminal.slug,
            ])
          );

          Object.keys(terminals).forEach((terminalId) => {
            const terminalSlug = terminalSlugs[terminalId];
            terminals[terminalSlug] = {
              ...terminals[terminalId],
              gate_schedules: {},
            };
            delete terminals[terminalId];
            Object.keys(availability).forEach((date) => {
              terminals[terminalSlug].gate_schedules[date] = {};

              if (availability[date][terminalId]) {
                const shifts = availability[date][terminalId];

                Object.keys(shifts).forEach((shiftKey) => {
                  const status = shifts[shiftKey].status;

                  terminals[terminalSlug].gate_schedules[date][shiftKey] = {
                    single: status,
                    dual: status === 1 || status === 2 ? 1 : status,
                    available_count: shifts[shiftKey].available_count,
                  };
                });
              }
            });
          });
          setAppointmentData(Object.values(terminals));

          if (res?.containerAppointments) {
            // Get first appointment from each terminal
            const terminalAppointments = Object.entries(
              res.containerAppointments
            )
              .map(([terminalId, appointments]) => {
                const firstAppointment = appointments[0];
                return {
                  [terminalId]: {
                    terminalId,
                    id: firstAppointment?.id,
                    status: firstAppointment?.status,
                    statusText: firstAppointment?.status_text,
                    date: firstAppointment?.terminal_appointment_availability?.date?.replace(
                      /(\d{2})-(\d{2})-(\d{4})/,
                      '$2/$1/$3'
                    ),
                    dateTocheck:
                      firstAppointment?.terminal_appointment_availability
                        ?.date_to_check,
                    terminal:
                      firstAppointment?.terminal_appointment_availability
                        ?.terminal?.slug,
                    time: `${firstAppointment?.terminal_appointment_availability?.time_start} - ${firstAppointment?.terminal_appointment_availability?.time_end}`,
                    type: 1,
                    shift: Number(
                      firstAppointment?.terminal_appointment_availability?.shift.replace(
                        /shift/,
                        ''
                      )
                    ),
                    selectId:
                      firstAppointment?.terminal_appointment_availability?.id,
                    license_plate: firstAppointment?.license_plate,
                    reserve_history: firstAppointment?.reserve_history || [],
                    terminal_name:
                      firstAppointment?.terminal_appointment_availability
                        ?.terminal?.name,
                    terminal_address:
                      firstAppointment?.terminal_appointment_availability
                        ?.terminal?.address,
                    terminal_website:
                      firstAppointment?.terminal_appointment_availability
                        ?.terminal?.website,
                    terminal_links:
                      firstAppointment?.terminal_appointment_availability
                        ?.terminal?.links,
                    total_appointments: appointments.length,
                  },
                };
              })
              .reduce((acc, curr) => ({ ...acc, ...curr }), []);

            setAppointmentSet(terminalAppointments);
          }
          setLoading(false);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      setTimeout(() => {
        setLoading(false);
      }, 1500);
    }
  }, [
    selected?.SSL?.value,
    selected?.Size?.value,
    selected?.Container?.value,
    SSLOptions,
    sizeOptions,
  ]);
  console.log(loading);

  const getFilters = () => {
    NewAppointmentsFilter({
      company: selected?.SSL?.value,
      specifiation: selected?.Size?.value,
    }).then((res) => {
      const cab = `c${selected?.SSL?.value}_s${selected?.Size?.value}`;
      setCabinId(cabins[cab]);
      setContainerOptions(
        res.data.containers.map((item) => ({
          value: item?.id,
          label: item?.name,
          SSL: {
            value: item?.inventory?.cabin?.company.id,
            label: item?.inventory?.cabin?.company.name,
          },
          Size: {
            value: item?.inventory?.cabin?.specifications?.id,
            label: `${item?.inventory?.cabin?.specifications?.size}${
              item?.inventory?.cabin?.specifications?.name
                ? '-' + item?.inventory?.cabin?.specifications?.name
                : ''
            }-${item?.inventory?.cabin?.specifications?.model}`,
          },
          cabinId: item?.inventory?.cabin?.id,
        }))
      );
    });
  };
  useEffect(() => {
    !changeConatiner && getFilters();
  }, [selected?.SSL, selected?.Size, changeConatiner]);

  const onChange = (key, item) => {
    setChangeConatiner(false);
    setSelected((prev) => ({ ...prev, Container: {}, [key]: item }));
  };
  const onChangeContainer = (item) => {
    setChangeConatiner(true);
    setSelected({
      Size: item?.Size,
      SSL: item?.SSL,
      Container: item,
    });
    setCabinId(item?.cabinId);
  };
  const onCreateOptionContainer = (item) => {
    setChangeConatiner(true);
    setSelected((prev) => ({
      ...prev,
      Container: {
        ...item,
        label: `${item}`,
        value: `${item}`,
      },
    }));
  };

  // const handleGetApointment = (e) => {
  //   const value = e.target.value;
  //   debouncedResults(value);
  // };

  const debouncedResults = useMemo(() => {
    return debounce(() => {
      getApointment();
      console.log('debouncedResults');
    }, 500);
  }, [getApointment]);

  useEffect(() => {
    return () => {
      debouncedResults.cancel();
    };
  }, [debouncedResults]);

  // مدیریت loading برای تغییرات selected
  useEffect(() => {
    if (selected?.SSL?.value && selected?.Size?.value) {
      setLoading(true);
    }
  }, [selected?.SSL?.value, selected?.Size?.value]);

  useEffect(() => {
    // فقط زمانی اجرا می‌شود که مقادیر SSL یا Size تغییر کرده باشند
    if (selected?.SSL?.value && selected?.Size?.value) {
      debouncedResults();
      console.log('selected');
    }
  }, [selected?.SSL?.value, selected?.Size?.value, debouncedResults]);

  return (
    <div className="overflow-x-auto">
      <PageContainerAB
        minWidth={1266}
        title="New Appointment"
        mainPage={true}
        basePath="/appointment/new">
        <div className="mt-4">
          <CustomGrid>
            <CustomGridItem xs={2} sm={2} md={2}>
              <CustomSelectEx
                dropdown={true}
                title={'Size'}
                placeholder={
                  selectedFromApi?.Size?.label !== null
                    ? selectedFromApi?.Size?.label
                    : selected?.Size
                    ? selected.Size.label
                    : 'Size'
                }
                value={
                  selectedFromApi?.Size?.label !== null
                    ? selectedFromApi?.Size
                    : selected?.Size
                }
                onChange={(item) => onChange('Size', item)}
                options={sizeOptions}
              />
            </CustomGridItem>
            <CustomGridItem xs={2} sm={2} md={2}>
              <CustomSelectEx
                dropdown={true}
                title={'SSL'}
                placeholder={
                  selectedFromApi?.SSL?.label !== null
                    ? selectedFromApi?.SSL?.label
                    : selected?.SSL
                    ? selected.SSL.label
                    : 'SSL'
                }
                value={
                  selectedFromApi?.SSL?.label !== null
                    ? selectedFromApi?.SSL
                    : selected?.SSL
                }
                onChange={(item) => onChange('SSL', item)}
                options={SSLOptions}
              />
            </CustomGridItem>
            <CustomGridItem xs={2} sm={2} md={2}>
              <CustomSelectEx
                dropdown={true}
                title="Container"
                placeholder="Container"
                value={selected.Container}
                onChange={onChangeContainer}
                options={ContainerOptions}
                AddOption={true}
                Err={'Invalid container number (11 characters required).'}
                onCreateOptionContainer={onCreateOptionContainer}
                // onCreateOption={(inputValue) => {
                //   // This won't add to the list, just logs if needed
                //   console.log('Temp created:', inputValue);
                // }}
              />
            </CustomGridItem>
            <CustomGridItem xs={6} sm={6} md={6}></CustomGridItem>
          </CustomGrid>
          {loading ? (
            <div className="flex items-center justify-center h-full mt-16">
              <LoadingV2 />
            </div>
          ) : (
            <AppointmentTable
              data={appointmentData}
              shift={shift}
              loading={loading}
              cabinId={cabinId}
              setAppointmentSet={setAppointmentSet}
              containerName={selected?.Container?.label}
              appointmentSet={appointmentSet}
              ContainerOptions={ContainerOptions}
              Container={selected?.Container}
              SSL={selected?.SSL?.label}
              Size={selected?.Size?.label}
              setSelected={setSelected}
            />
          )}
        </div>
      </PageContainerAB>
    </div>
  );
};
